import { GetComponentProps, styled } from 'topwrite';
import { Children } from 'react';

export default function Columns({ props }: GetComponentProps<any>) {

    const { children } = props;

    const columns = Children.toArray(children).map(({ props }: any, index) => {
        //TODO 内置支持判断
        if (props.tagName === 'containerDirective' && props.name === 'column') {
            const [, ...content] = Children.toArray(props.children);
            return <Column key={`index-${index}`}>{content}</Column>;
        }
        return null;
    }).filter(column => !!column);

    return <Container columns={columns.length}>
        {columns}
    </Container>;
}

export const Column = styled.div`
  & > *:first-child {
    margin-top: 0 !important;
  }

  & > *:last-child {
    margin-bottom: 0 !important;
  }
`;


export const Container = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns:${props => `repeat(${props.columns}, calc(${100 / props.columns}% - ${(props.columns - 1) / props.columns}em))`};
  margin: 1em 0;
  column-gap: 1em;
  @media (max-width: 996px) {
    grid-template-columns: 100%;
    row-gap: 1em;
  }
`;
